export enum WebhooksTypes {
  FetchSubscriptionsRequest = 'webhooks.FetchSubscriptions.Request',
  FetchSubscriptionsSuccess = 'webhooks.FetchSubscriptions.Success',
  FetchSubscriptionsFailure = 'webhooks.FetchSubscriptions.Failure',
  CreateSubscriptionRequest = 'webhooks.CreateSubscription.Request',
  CreateSubscriptionSuccess = 'webhooks.CreateSubscription.Success',
  CreateSubscriptionFailure = 'webhooks.CreateSubscription.Failure',
  DeleteSubscriptionRequest = 'webhooks.DeleteSubscription.Request',
  DeleteSubscriptionSuccess = 'webhooks.DeleteSubscription.Success',
  DeleteSubscriptionFailure = 'webhooks.DeleteSubscription.Failure',
  UpdateSubscriptionRequest = 'webhooks.UpdateSubscription.Request',
  UpdateSubscriptionSuccess = 'webhooks.UpdateSubscription.Success',
  UpdateSubscriptionFailure = 'webhooks.UpdateSubscription.Failure',
  FetchEventsRequest = 'webhooks.FetchEvents.Request',
  FetchEventsSuccess = 'webhooks.FetchEvents.Success',
  FetchEventsFailure = 'webhooks.FetchEvents.Failure',
  FetchErrorsRequest = 'webhooks.FetchErrors.Request',
  FetchErrorsSuccess = 'webhooks.FetchErrors.Success',
  FetchErrorsFailure = 'webhooks.FetchErrors.Failure',
  TestEndpointRequest = 'webhooks.TestEndpoint.Request',
  TestEndpointSuccess = 'webhooks.TestEndpoint.Success',
  TestEndpointFailure = 'webhooks.TestEndpoint.Failure',
  FetchDeliveryAttemptsRequest = 'webhooks.FetchDeliveryAttempts.Request',
  FetchDeliveryAttemptsSuccess = 'webhooks.FetchDeliveryAttempts.Success',
  FetchDeliveryAttemptsFailure = 'webhooks.FetchDeliveryAttempts.Failure',
  FetchWebhookEventRequest = 'webhooks.FetchWebhookEvent.Request',
  FetchWebhookEventSuccess = 'webhooks.FetchWebhookEvent.Success',
  FetchWebhookEventFailure = 'webhooks.FetchWebhookEvent.Failure',
}
